import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Radio = createReactComponent("Radio", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "2",
  key: "1pacaq"
}], ["path", {
  d: "M16.24 7.76a6 6 0 010 8.49m-8.48-.01a6 6 0 010-8.49m11.31-2.82a10 10 0 010 14.14m-14.14 0a10 10 0 010-14.14",
  key: "mmj8hz"
}]]]);
export default Radio;